import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";
import { Toaster } from "./components/ui/sonner";

import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import MapPage from "./pages/MapPage";
import Tours from "./pages/Tours";
import CustomerPortal from "./pages/CustomerPortal";
import Team from "./pages/Team";
import Agency from "./pages/Agency";
import Reports from "./pages/Reports";
import Documents from "./pages/Documents";
import Invoices from "./pages/Invoices";
import Time from "./pages/Time";
import Chat from "./pages/Chat";
import Settings from "./pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-12 h-12 rounded-full border-4 border-primary/30 border-t-primary animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function StaffOnly({ children }) {
  const { user } = useAuth();
  if (user?.role === "customer") return <Navigate to="/portal" replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user?.role === "customer") return <Navigate to="/portal" replace />;
  return <Dashboard />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Home />} />
              <Route path="portal" element={<CustomerPortal />} />
              <Route path="agency" element={<AdminOnly><Agency /></AdminOnly>} />
              <Route path="jobs" element={<StaffOnly><Jobs /></StaffOnly>} />
              <Route path="map" element={<StaffOnly><MapPage /></StaffOnly>} />
              <Route path="tours" element={<StaffOnly><Tours /></StaffOnly>} />
              <Route path="team" element={<AdminOnly><Team /></AdminOnly>} />
              <Route path="reports" element={<StaffOnly><Reports /></StaffOnly>} />
              <Route path="documents" element={<Documents />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="time" element={<StaffOnly><Time /></StaffOnly>} />
              <Route path="chat" element={<Chat />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
